<template>
  <div class="card-questions">
    <p v-if="question.type === 'merged'" class="card-question">
      {{ $t('categoryDetails.condensedQuestionTitlePrefix') }}:
      {{ $tr(question.messages, 'title') }}
    </p>
    <p v-else class="card-question">{{ $tr(question.messages, 'title') }}</p>
    <ul v-if="question.hasRanges" class="list-group">
      <li
        v-for="(answer, i) in question.rangeKeys"
        :key="answer"
        class="list-group-item d-flex"
        style="padding: 5px 15px"
        :class="classesForListItem(answer)"
      >
        <p class="me-2 mb-0">{{ labelData[i].name }}:</p>
        <p class="mb-0">
          {{ $tr(question.messages, 'ranges')[answer] }}
        </p>
        <!-- <p class="me-2 mb-0">{{ question.messages.ranges[key] }}:</p> -->
        <!-- <p class="mb-0">
          {{ question.textForValueAndQuestionMessages(key, question.messages) }}
        </p> -->
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'QuestionDetailsTitle',
  props: {
    question: Object,
    labelData: Array,
    isIndividualGroup: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    classesForListItem(answer) {
      const quizClasses =
        Object.keys(this.question).includes('correctAnswer') &&
        this.question.correctAnswer === parseInt(answer)
          ? 'list-group-item-bg-success'
          : ''
      const ownResponseClasses =
        this.isIndividualGroup && this.question.value === parseInt(answer)
          ? 'is-own-response'
          : ''
      return quizClasses.concat(ownResponseClasses)
    }
  }
}
</script>

<style>
.is-own-response {
  background-color: rgb(var(--kt-primary-rgb), 0.3) !important;
}
</style>
